import { defineComponent, h } from 'vue';
import { QBtn, QIcon } from 'quasar';
import utils from "../../Shared/utils.jsx";
import BaseComponent from "./BaseComponentMixin.jsx";
import { appSettings } from "../../Shared/appSettings.js";
import SAMLPopupManger from "./javascript/SAMLButtonSSOPopupManager";
import { outlinePrimaryQBtnClassNames } from '../../Shared/buttonAppearance.js';
import TranslationContainer from './TranslationContainer.jsx';
import './css/BasicButton.css';

export default defineComponent({
    name: 'saml-button',
    components: { QBtn, QIcon, TranslationContainer },
    mixins: [BaseComponent],
    data: function() {
        return {
            textexpn: null,
        };
    },
    computed: {
        buttonTextKey() {
            if (!this.textexpn && this.controlData.Text)
                this.textexpn = utils.compile(this, this.controlData.Text);

            return this.textexpn ? utils.evaluate(this.textexpn, this) : '';
        },
        samlIssuer() {
            if (!this.issuerexpn && this.controlData.SAMLIssuer)
                this.issuerexpn = utils.compile(this, this.controlData.SAMLIssuer);

            return this.issuerexpn ? utils.evaluate(this.issuerexpn, this) : '';
        },
        autoLogin() {
            if (!this.autologinexpn && this.controlData.AutoLogin)
                this.autologinexpn = utils.compile(this, this.controlData.AutoLogin);

            return this.autologinexpn ? utils.evaluate(this.autologinexpn, this) : false;
        },
        styles() {
            return {
                ...this.sizeStyle,
                ...utils.resolveStyleHints(this.styleHints, this),
            };
        },
    },

    //Created replaced with preRenderComplete
    methods: {
        async preRenderComplete() {
            this.finishRenderHandler(this);

            if ((this.autoLogin === true || this.autoLogin === "true") && !utils.isSsoAutoLoginSuppressed())
                this.onclick(false);
        },
        async RunActions(authArgs) {
            await utils.executeAndCompileAllActions(this.controlData.Actions, authArgs, this);
        },

        onclick(userInitiated = true) {
            if (!userInitiated && utils.isSsoAutoLoginSuppressed())
                return;

            if (userInitiated)
                utils.clearSsoAutoLoginSuppression();

            const popupManager = new SAMLPopupManger();
            popupManager.open(this.samlIssuer).then((SAMLResponse) => {
                var authargs = {
                    ProviderType: 'SAML',
                    token: SAMLResponse,
                };

                this.RunActions(authargs);
            },
                (result) => {
                    // SAML login was not successful (user either didn't login properly or closed dialog)   
                }
            );

            //care.sendUIEvent(c.$controlModel, "Click");
        },
    },
    render() {
        try {
            if (!this.todisplay) return null;

            return (
                <div
                    style={this.styles}
                    class={{ "c-SAMLButton flex": true, [`c-name-${this.name || "unnamed"}`]: true }}
                >
                    <QBtn
                        color="primary"
                        outline
                        no-caps
                        size="14px"
                        full-width
                        align="center"
                        class={outlinePrimaryQBtnClassNames({ useLiteralCasing: true })}
                        onClick={this.onclick}
                        style="width: 100%;"
                    >
                        <TranslationContainer context={this} value={this.buttonTextKey} />
                    </QBtn>
                </div>
            );
        } catch (e) {
            utils.error("SAMLButton Render failed", e);
            return <div>SAMLButton Failed to Render {e}</div>;
        }
    },
});
